import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-penalty-history',
  templateUrl: './penalty-history.component.html',
  styleUrls: ['./penalty-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PenaltyHistoryComponent implements OnInit {

  @Input() getVslCode:string;
  @Input() penaltyHistoryPool:any;
  @Input() penaltyHistoryShip:any;
  @Input() shipVslNumber:any; 
  getPenaltyHistoryListData: any = [];
  deletePenalty:boolean = false;
  isError:boolean = false;
  penaltyHistoryColumnHeader =[
    {'name':'Action', 'width': '80px','value':'action'},
    {'name':'Penalty value', 'width': '98px','value':'penaltyval'},
    {'name':'Effective pool points', 'width': '122px','value':'poolPoints'},
    {'name':'From', 'width': '144px','value':'penaltyFrom'},
    {'name':'To', 'width': '144px','value':'penaltyTo'},
    {'name':'Duration (days)', 'width': '104px','value':'duration'},
    {'name':'Status', 'width': '128px','value':'status'},
    {'name':'Reason for penalty', 'width': '264px','value':'reason'},
    {'name':'Last updated', 'width': '200px','value':'date'}
  ];
  deletePenaltyModalData: any;
  currentYear: number;
  removePenaltyHistoryReason: string = '';

  constructor( private _vesselService: VesselsService, private toasterService: ToasterService, private datePipe: DatePipe) {
  }

  ngOnInit() {
    this.getPenaltyHistoryList();
    this.currentYear = new Date().getFullYear();
  }
   getMonthShort(month: number): string {
    return new Date(0, month - 1).toLocaleString('en', { month: 'short' });
  }
  getPenaltyHistoryList(){
    document.body.style.overflow = 'auto';
    let payLoad = {
      vslCode : this.getVslCode
    }
    this._vesselService.getPenaltyHistory(payLoad).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.getPenaltyHistory?.success){
          this.getPenaltyHistoryListData = res?.data?.getPenaltyHistory?.data;
        }else{
          this.toasterService.openToast('Error', res?.data?.message);
        }
          
      },
     error:(error:any)=>{
      this.toasterService.openToast('Error', error);
     }
    })
  }
  deletePenaltyHistoryEvent(data:any){
    // document.body.classList.add('addOverFlowClass');
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 1000);
    this.deletePenalty = true;
    this.deletePenaltyModalData = data;
    this.removePenaltyHistoryReason = '';
    console.log(data)
    
  }
  penaltyHistoryFieldVal(e:any){
    console.log(e)
    this.removePenaltyHistoryReason =e
  }
  penaltyRemoved(){
    let removePenaltyTodayDate = new Date();
    console.log(removePenaltyTodayDate)
    let removePenaltyOnlyDate = this.datePipe.transform(removePenaltyTodayDate,"yyyy-MM-dd");
    let removePenaltyOnlyTime = this.datePipe.transform(removePenaltyTodayDate, 'HH:mm');
    let payLoad = {
      "vslCode": this.getVslCode,
      "vslNumber": this.shipVslNumber,
      "penaltyValue": this.deletePenaltyModalData?.effectivePoolPoints,
      "penaltyPercentage": this.deletePenaltyModalData?.penaltyValue,
      "penaltyCloseEffectiveDate": removePenaltyOnlyDate,
      "penaltyCloseEffectiveTime": removePenaltyOnlyTime,
      "penaltyReason": this.removePenaltyHistoryReason
    }
    this._vesselService.removePenalty(payLoad).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.removePenalty?.statusCode === 200){
          // this.showPenalty = false;
          this.toasterService.openToast('Success', res?.data?.removePenalty?.message);
          this.getPenaltyHistoryList();
          this.removePenaltyHistoryReason = ''
        }else{
          this.removePenaltyHistoryReason = ''
          this.toasterService.openToast('Error', res?.data?.removePenalty?.message);
        }
      },
      error:(error:any)=>{
        // this.showPenalty = true;
        this.removePenaltyHistoryReason = ''
        this.toasterService.openToast('Error', error?.data?.removePenalty?.message);
      }
    })
  }
  cancelDeletePenalty(){
    this.deletePenalty = false;
    document.body.style.overflow = 'auto';
  }
  // ngOnDestroy(){
  //    document.body.classList.remove('addOverFlowClass');
  // }
    
}